ht.toPascalCase = (str) => {
  let cleanedStr = str.replace(/[^a-zA-Z]/g, ' ');

  return cleanedStr
    .split(' ')
    .filter((word) => word !== '')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
};
